// extracted by mini-css-extract-plugin
export var barContainer = "_4g-0";
export var extraThin = "_4g-3";
export var fillBar = "_4g-6";
export var fillContainer = "_4g-4";
export var overflow = "_4g-8";
export var overflowContainer = "_4g-5";
export var regular = "_4g-7";
export var thick = "_4g-1";
export var thin = "_4g-2";